import { EntityAPIGatewayCard } from '@internal/plugin-api-gateway';
import React from 'react';

import { EntityLayout } from '@backstage/plugin-catalog';

import { Grid } from '@material-ui/core';

import { ActionContent, EntityWarningContent } from '../Content';

export const ProxyPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        <EntityWarningContent />
        {ActionContent}
        <Grid item md={6}>
          <EntityAPIGatewayCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
